import React, { useCallback, useEffect, useMemo } from 'react';
import { ScopeForm } from 'modules/settings/submodules/clients/scopes/components/ScopeForm/ScopeForm';
import { setEditScopeId, updateScope } from 'modules/settings/submodules/clients/scopes/store/actions';
import { IScopeModifyRequest } from 'modules/settings/submodules/clients/scopes/store/models';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ModalDialog } from 'shared/components/modals/ModalDialog';
import { selectEditScope, selectScopeIsUpdating } from 'modules/settings/submodules/clients/scopes/store/selector';
import { useColoredFormModalStyles } from 'shared/components/modals/ModalStyles';
import { ScopeType } from 'store/entities/scopes/models';
import { getScopeFull } from '../../../../../../../store/entities/scopes/actions';
import { selectFullScopesByIds } from '../../../../../../../store/entities/customFields/selectors';

export default function EditScopeModal() {
    const dispatch = useDispatch();
    const classes = useColoredFormModalStyles();
    const { type } = useParams<{ type: ScopeType }>();

    const isLoading = useSelector(selectScopeIsUpdating);
    const scopeLight = useSelector(selectEditScope);
    const scopesFull = useSelector(selectFullScopesByIds);
    const scope = useMemo(() => {
        if (scopeLight && scopesFull) {
            return scopesFull[scopeLight.id];
        }
        return null;
    }, [scopeLight, scopesFull]);

    useEffect(() => {
        if (scopeLight?.id) {
            dispatch(getScopeFull.init(scopeLight?.id ?? ''));
        }
    }, [dispatch, scopeLight?.id]);

    const onSave = useCallback((values: IScopeModifyRequest) => {
        dispatch(updateScope.init({
            id: scope.id,
            data: values,
        }));
    }, [dispatch, scope]);
    const onClose = useCallback(() => {
        dispatch(setEditScopeId(null));
    }, [dispatch]);

    return (
        <ModalDialog
            title="Edit Scope"
            isOpened={Boolean(scope)}
            onClose={onClose}
            modalProps={{
                customClasses: classes,
                showCloseIcon: true,
            }}
        >
            <ScopeForm
                onSubmit={onSave}
                isLoading={isLoading}
                type={type}
                scope={scope}
                buttonText="Save"
            />
        </ModalDialog>
    );
}
